










































































































































































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import MoreVertBtn from "../common/MoreVertBtn.vue";
import { IAction } from "../common/CommonTypes";
import { Organization, isEco2, isClient } from "../common/Organization.enum";
import VueI18n from "vue-i18n";
import {
  TreatmentRequestsApi,
  ShipmentCertificatesApi,
  CustomersApi,
  LocationsApi,
  UnitsApi,
  FailureTrackingsApi,
  TreatmentRequestModel,
  StatisticsModel,
} from "../../../apis";

import {
  IChartLabels,
  ITotalItem,
  IN_REQUEST,
  IN_PROGRESS,
  FINISHED,
  TREATMENT_SPECIAL,
  FAILURE,
  PENDING,
  SPECIAL,
  BASE_CHART_INIT,
  DRAFT,
  VALID,
  ACCEPTED,
  NEEDSUPPORT,
  APPROVED,
  REJECTED,
  CANCELED,
  CANCELLED,
} from '.';
import {numeric} from 'vee-validate/dist/rules';

@Component({
  components: {
    MoreVertBtn,
  },
})
export default class AdminHome extends Vue {
  IN_REQUEST = IN_REQUEST;
  IN_PROGRESS = IN_PROGRESS;
  FINISHED = FINISHED;

  treatmentRequestChartOptions;
  certificationsChartOptions;

  treatmentRequestSeries = [];
  certificationsSeries = [];

  treatmentRequestLegend;
  certificationsLegend;

  statisticsDataTreatment: StatisticsModel[] = null;
  statisticsDataShipment: StatisticsModel[] = null;
  totalValues = [0, 0, 0];

  treatmentInRequestFullData = [];
  treatmentInRequestKeyword = "";
  treatmentInRequestPage = 1;
  treatmentInRequestLoading = false;
  treatmentInRequestDebounceFn = () => {};

  treatmentInProgressFullData = [];
  treatmentInProgressKeyword = "";
  treatmentInProgressPage = 1;
  treatmentInProgressLoading = false;
  treatmentInProgressDebounceFn = () => {};


  treatmentFinishedFullData = [];
  treatmentFinishedKeyword = "";
  treatmentFinishedPage = 1;
  treatmentFinishedLoading = false;
  treatmentFinishedDebounceFn = () => {};

  failureTrackingFullData = [];
  failureTrackingKeyword = "";
  failureTrackingPage = 1;
  failureTrackingLoading = false;
  failureTrackingDebounceFn = () => {};
  loading = false;
  intervalId = null;

  created() {
    this.initChart();
    this.initData();
    this.clearInterval();
    this.intervalId = setInterval(() => {
      this.initData(false);
    }, 1000 * 60);
  }

  clearInterval() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
    this.failureTrackingDebounceFn = this.lodash.debounce(async () => {
      this.failureTrackingPage = 1;
      await this.getFailureTrackings();
      const table: any = this.$refs["failure-table"];
      const wrapper = table.$el.querySelector("div.v-data-table__wrapper");
      this.$vuetify.goTo(table, { container: wrapper }); // to header
    }, 500);
    this.treatmentInRequestDebounceFn = this.lodash.debounce(async () => {
      this.treatmentInRequestPage = 1;
      await this.getTreatmentRequest(IN_REQUEST, true);
      const table: any = this.$refs["inrequest-table"];
      const wrapper = table.$el.querySelector("div.v-data-table__wrapper");
      this.$vuetify.goTo(table, { container: wrapper }); // to header
    }, 500);
    this.treatmentInProgressDebounceFn = this.lodash.debounce(async () => {
      this.treatmentInProgressPage = 1;
      await this.getTreatmentRequest(IN_PROGRESS, true);
      const table: any = this.$refs["inprogress-table"];
      const wrapper = table.$el.querySelector("div.v-data-table__wrapper");
      this.$vuetify.goTo(table, { container: wrapper }); // to header
    }, 500);
    this.treatmentFinishedDebounceFn = this.lodash.debounce(async () => {
      this.treatmentFinishedPage = 1;
      await this.getTreatmentRequest(FINISHED, true);
      const table: any = this.$refs["finished-table"];
      const wrapper = table.$el.querySelector("div.v-data-table__wrapper");
      this.$vuetify.goTo(table, { container: wrapper }); // to header
    }, 500);
  }

  beforeDestroy() {
    this.clearInterval();
    if (typeof window === "undefined") return;
    window.removeEventListener("resize", this.onResize, {
      passive: true,
    } as any);
  }

  initChart() {
    const treatmentReqLabels: Array<IChartLabels> = [
      {
        title: this.$t("text.inRequest").toString(),
        color: "#f9cf26",
        key: IN_REQUEST,
      },
      {
        title: this.$t("text.inProgress").toString(),
        color: "#42d69e",
        key: IN_PROGRESS,
      },
      {
        title: this.$t("text.cancelled").toString(),
        color: "#e54949",
        key: CANCELLED,
      },
      {
        title: this.$t("text.finished").toString(),
        color: "#2a7de9",
        key: FINISHED,
      },
    ];

    this.treatmentRequestChartOptions = this.createChart(treatmentReqLabels);
    this.treatmentRequestSeries = [0, 0, 0, 0];
    this.treatmentRequestLegend = this.treatmentRequestSeries.map(
      (seri, i: number) => ({
        ...treatmentReqLabels[i],
        value: seri,
      })
    );
    const certificationsLabels: Array<IChartLabels> = [
      {
        title: this.$t("status.VALID").toString(),
        color: "#2A7DE9",
        key: VALID,
      },
      {
        title: this.$t("status.ACCEPTED").toString(),
        color: "#EEAE4E",
        key: ACCEPTED,
      },
      {
        title: this.$t("status.NEEDSUPPORT").toString(),
        color: "#DE682B",
        key: NEEDSUPPORT,
      },
      {
        title: this.$t("status.APPROVED").toString(),
        color: "#00B162",
        key: APPROVED,
      },
      {
        title: this.$t("status.REJECTED").toString(),
        color: "#E54949",
        key: REJECTED,
      },
      {
        title: this.$t("status.CANCELED").toString(),
        color: "#8A8A8A",
        key: CANCELED,
      },
    ];
    this.certificationsChartOptions = this.createChart(certificationsLabels);
    this.certificationsSeries = [0, 0, 0, 0, 0, 0];
    this.certificationsLegend = this.certificationsSeries.map(
      (seri, i: number) => ({
        ...certificationsLabels[i],
        value: seri,
      })
    );
  }

  createChart(labels: Array<IChartLabels>) {
    const baseChart = {
      ...BASE_CHART_INIT,
      colors: labels.map((label) => label.color),
      labels: labels.map((label) => label.title),
    };
    return baseChart;
  }

  reinitData() {
    this.treatmentInRequestPage = 1;
    this.treatmentInProgressPage = 1;
    this.treatmentFinishedPage = 1;
    this.failureTrackingPage = 1;
  }

  async initData(loadingOn: boolean = true) {
    try {
      if (loadingOn) this.$util.showLoading();
      if (!loadingOn) {
        this.reinitData();
      }
      this.loading = true;
      const [
        statisticsDataTreatmentRes,
        statisticsDataShipmentRes,
        totalCustomerRes,
        totalLocationRes,
        totalUnitRes,
      ] = await Promise.all([
        new TreatmentRequestsApi().statisticsDataTreatment(),
        new ShipmentCertificatesApi().statisticsDataShipment(),
        new CustomersApi().getTotalCustomer(),
        new LocationsApi().getTotalLocation(),
        new UnitsApi().getTotalUnit(),
        this.getFailureTrackings(),
        this.getTreatmentRequest(IN_REQUEST, true),
        this.getTreatmentRequest(IN_PROGRESS, true),
        this.getTreatmentRequest(FINISHED, true),
      ]);
      // chart and total
      this.statisticsDataTreatment = statisticsDataTreatmentRes.data.data;
      this.statisticsDataShipment = statisticsDataShipmentRes.data.data;
      if (this.$util.isClient()) {
        this.totalValues = [this.totalLocations.value, this.totalUnits.value] =
          [totalLocationRes.data.data, totalUnitRes.data.data];
      } else {
        this.totalValues = [
          this.totalCustomers.value,
          this.totalLocations.value,
          this.totalUnits.value,
        ] = [
          totalCustomerRes.data.data,
          totalLocationRes.data.data,
          totalUnitRes.data.data,
        ];
      }
      const buildSeries = (
        legends,
        dataStatistics: StatisticsModel[]
      ): number[] => {
        return legends.map(
          (legend) =>
            dataStatistics.find((statistic) => legend.key === statistic.status)
              .count
        );
      };
      this.treatmentRequestSeries = buildSeries(
        this.treatmentRequestLegend,
        this.statisticsDataTreatment
      );
      this.certificationsSeries = buildSeries(
        this.certificationsLegend,
        this.statisticsDataShipment
      );
      this.$nextTick(() => {
        this.currentViewTotalCard.value = this.totalValues[0];
        if (this.$refs.treatmentRequestChart)
          (this.$refs.treatmentRequestChart as any).refresh();
        if (this.$refs.certificationsChart)
          (this.$refs.certificationsChart as any).refresh();
      });
      this.treatmentRequestLegend = this.treatmentRequestLegend.map(
        (legend, index) => ({
          ...legend,
          value: this.treatmentRequestSeries[index],
        })
      );
      this.certificationsLegend = this.certificationsLegend.map(
        (legend, index) => ({
          ...legend,
          value: this.certificationsSeries[index],
        })
      );
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
      this.loading = false;
    }
  }

  filterResults(list, keyword, ignoreKeys = ["id"]) {
    if (!keyword) return list;
    return list.filter((v) => {
      return Object.keys(v)
        .filter((key) => !ignoreKeys.includes(key))
        .some((k) => {
          return v[k].toString().toLowerCase().indexOf(keyword) > -1;
        });
    });
  }

  redirectToTreatmentRequestByStatus(status: string) {
    return this.$router.push({
      name: "treatment-request",
      query: { status: status, redirectFrom: "home" },
    });
  }

  redirectToFailureList() {
    return this.$router.push({
      name: "failure-tracking",
      query: { redirectFrom: "home" },
    });
  }

  redirectToAddTreatmentRequest() {
    return this.$router.push({
      name: "add-treatment-request",
      query: { redirectFrom: "home" },
    });
  }

  getTotalBySeries(series: number[]) {
    const total = series.reduce((a, b) => a + b, 0);
    return new Intl.NumberFormat("en-US").format(total);
  }

  totalCustomers: ITotalItem = {
    key: "totalCustomers",
    title: this.$t("text.totalCustomers"),
    value: 0,
    color: "#E95050",
  };

  totalLocations: ITotalItem = {
    key: "totalLocations",
    title: this.$t("text.totalLocations"),
    value: 0,
    color: "#eeae4e",
  };

  totalUnits: ITotalItem = {
    key: "totalUnits",
    title: this.$t("text.totalUnits"),
    value: 0,
    color: "#47ce97",
  };

  get TOTAL_ITEMS_DEFAULT(): Array<ITotalItem> {
    if (!this.$util.isClient()) {
      return [this.totalCustomers, this.totalLocations, this.totalUnits];
    }
    if (this.$util.isClient()) {
      return [this.totalLocations, this.totalUnits];
    }
  }

  totalItemList: Array<ITotalItem> = this.TOTAL_ITEMS_DEFAULT;

  currentViewTotalCard: ITotalItem = this.TOTAL_ITEMS_DEFAULT[0];
  onViewNextTotal() {
    const currentIndex = this.TOTAL_ITEMS_DEFAULT.indexOf(
      this.currentViewTotalCard
    );
    const nextIndex = (currentIndex + 1) % this.TOTAL_ITEMS_DEFAULT.length;
    this.currentViewTotalCard = this.TOTAL_ITEMS_DEFAULT[nextIndex];
    this.totalItemList = [this.currentViewTotalCard];
  }

  getColor(status) {
    if (status == FAILURE) return "#FF6060";
    else if (status == PENDING) return "#F2BB25";
    else if (status == IN_REQUEST) return "#F2BB25";
    else if (status == IN_PROGRESS) return "#00B162";
    else if (status == FINISHED) return "#152235";
    else if (status == CANCELLED) return "#E54949";
  }

  getLabel(status): string | VueI18n.TranslateResult {
    switch (status) {
      case IN_REQUEST: {
        return this.$t("text.inRequest");
      }
      case IN_PROGRESS: {
        return this.$t("text.inProgress");
      }
      case FINISHED: {
        return this.$t("text.finished");
      }
      case CANCELLED: {
        return this.$t("text.cancelled");
      }
      case FAILURE: {
        return this.$t("text.failure");
      }
      case PENDING: {
        return this.$t("text.pending");
      }
      default: {
        return;
      }
    }
  }

  isHDScreen = false;
  isEllipsisAddtreatmentRequest = false;
  onResize() {
    this.$nextTick(() => {
      const navigationDrawer = document.getElementById("navigationDrawer");
      if (navigationDrawer) {
        const navWidth = navigationDrawer.offsetWidth;
        this.isHDScreen = window.innerWidth < 1264 + navWidth + 61;
        if (this.isHDScreen) {
          this.totalItemList = [this.currentViewTotalCard];
        } else {
          this.totalItemList = this.TOTAL_ITEMS_DEFAULT;
        }
      }
      const newLocal = document.getElementById(
        "table-title-block-treatmentReq"
      );
      if (newLocal) {
        const treatmentReqTitleBlockWidth = newLocal.offsetWidth;
        this.isEllipsisAddtreatmentRequest = treatmentReqTitleBlockWidth <= 570;
      }
    });
  }

  onClickLegend(event, legend, chartName) {
    if (legend.value === 0) return;
    this.triggerClickLegendBySeriesName(legend.title, chartName);
  }

  triggerClickLegendBySeriesName(
    seriesname: string,
    chartName: "certificationsChart" | "treatmentRequestChart"
  ) {
    seriesname = seriesname.replace(/[-\s]/g, "x");
    const [seri] = document.querySelectorAll(
      `div.apexcharts-legend-series[seriesname=${seriesname}] .apexcharts-legend-marker`
    ) as any;
    seri.click();
  }

  get headerTreatmentRequests() {
    return [
      {
        text: this.$t("text.no"),
        sortable: false,
        value: "no",
        class: " black--text",
      },
      {
        text: this.$t("text.treatmentNR"),
        value: "treatment",
        class: " black--text ",
      },
      {
        text: this.$t("text.location"),
        value: "location",
        class: " black--text",
      },
      {
        text: this.$t("text.unit"),
        value: "unit",
        class: " black--text",
      },
      {
        text: this.$t("text.status"),
        value: "status",
        class: " black--text",
      },
    ];
  }

  get headerFailureEvents() {
    return [
      {
        text: this.$t("text.no"),
        value: "no",
        class: " black--text",
      },
      {
        text: this.$t("text.failureName"),
        value: "failureName",
        class: " black--text",
      },
      {
        text: this.$t("text.location"),
        value: "location",
        class: " black--text",
      },
      {
        text: this.$t("text.dateOpen"),
        value: "dateOpen",
        class: " black--text",
      },
      {
        text: this.$t("text.dateClosed"),
        value: "dateClosed",
        class: "black--text",
        align: "center",
      },
    ];
  }

  infiniteScrolling(entries, observer, isIntersecting) {
    if (!isIntersecting) {
      return;
    }
    this.failureTrackingPage++;
    this.getFailureTrackings(true);
  }

  async getFailureTrackings(scroll: boolean = false) {
    let currentNo = 0;
    if (scroll) {
      this.failureTrackingLoading = true;
      currentNo = this.failureTrackingFullData.length;
    }
    const {
      data: { data },
    } = await new FailureTrackingsApi().getFailureTrackingsByKeyword({
      limit: 20,
      page: this.failureTrackingPage,
      keyword: this.failureTrackingKeyword || "",
    });
    const result = data.map((failure, index) => ({
      id: failure.id,
      status: failure.status,
      no: index + 1 + currentNo,
      failureName: failure.failureName,
      location: failure.location ? failure.location.locationName : "",
      dateOpen: this.$moment(failure.dateOpen).format("DD MMM, YYYY"),
      dateClosed:
        this.$moment(failure.dateClosed).format("DD MMM, YYYY") || "-",
    }));
    if (scroll) {
      this.failureTrackingLoading = false;
      this.failureTrackingFullData =
        this.failureTrackingFullData.concat(result);
    } else {
      this.failureTrackingFullData = result;
    }
  }

  infiniteScrollingTreatmentRequestInRequest(entries, observer, isIntersecting) {
    return this.infiniteScrollingTreatmentRequest(entries, observer, isIntersecting, IN_REQUEST);
  }

  infiniteScrollingTreatmentRequestInProgress(entries, observer, isIntersecting) {
    return this.infiniteScrollingTreatmentRequest(entries, observer, isIntersecting, IN_PROGRESS);
  }

  infiniteScrollingTreatmentRequestFinished(entries, observer, isIntersecting) {
    return this.infiniteScrollingTreatmentRequest(entries, observer, isIntersecting, FINISHED);
  }

  infiniteScrollingTreatmentRequest(entries, observer, isIntersecting, status) {
    if (!isIntersecting) {
      return;
    }
    switch (status) {
      case IN_REQUEST:
        this.treatmentInRequestPage++;
        break;
      case IN_PROGRESS:
        this.treatmentInProgressPage++;
        break;
      case FINISHED:
        this.treatmentFinishedPage++;
        break;
      default:
        break;
    }
    this.getTreatmentRequest(status, true, true);
  }

  async getTreatmentRequest(status, initSort = false, scroll: boolean = false) {
    let keyword = "";
    let currentNo = 0;
    let page = 0;
    const requestBody = {} as any;
    switch (status) {
      case IN_REQUEST:
        if (scroll) {
          this.treatmentInRequestLoading = true;
          currentNo = this.treatmentInRequestFullData.length;
        }
        keyword = this.treatmentInRequestKeyword;
        page = this.treatmentInRequestPage;
        break;
      case IN_PROGRESS:
        if (scroll) {
          this.treatmentInProgressLoading = true;
          currentNo = this.treatmentInProgressFullData.length;
        }
        if (initSort) {
          requestBody.orderBy = "startDate";
          requestBody.orderDesc = true;
        }
        keyword = this.treatmentInProgressKeyword;
        page = this.treatmentInProgressPage;
        break;
      case FINISHED:
        if (scroll) {
          this.treatmentFinishedLoading = true;
          currentNo = this.treatmentFinishedFullData.length;
        }
        if (initSort) {
          requestBody.orderBy = "endDate";
          requestBody.orderDesc = true;
        }
        keyword = this.treatmentFinishedKeyword;
        page = this.treatmentFinishedPage;
        break;
      default:
      break;
    }

    const createTreatmentItem = (
      treatment: TreatmentRequestModel,
      index
    ) => ({
      id: treatment["_id"],
      no: index + 1 + currentNo,
      treatment: treatment.number,
      location: treatment["locationName"],
      status: treatment.status,
      unit: treatment.unit,
    });
    requestBody.limit = 20;
    requestBody.keyword = keyword;
    requestBody.page = page;
    requestBody.status = status;
    const {
      data: { data },
    } = await new TreatmentRequestsApi().getTreatmentRequestsByKeyword(requestBody);
    const result = data.map((treatment, index) => createTreatmentItem(treatment, index));
    switch (status) {
      case IN_REQUEST:
        this.treatmentInRequestLoading = false;
        if (scroll) {
          this.treatmentInRequestFullData = this.treatmentInRequestFullData.concat(result);
        } else {
          this.treatmentInRequestFullData = result;
        }
        break;
      case IN_PROGRESS:
        this.treatmentInProgressLoading = false;
        if (scroll) {
          this.treatmentInProgressFullData = this.treatmentInProgressFullData.concat(result);
        } else {
          this.treatmentInProgressFullData = result;
        }
        break;
      case FINISHED:
        this.treatmentFinishedLoading = false;
        if (scroll) {
          this.treatmentFinishedFullData = this.treatmentFinishedFullData.concat(result);
        } else {
          this.treatmentFinishedFullData = result;
        }
        break;
      default:
        break;
    }
  }
}
